import React from 'react';
import Autocomplete from '@mui/material/Autocomplete';
import TextField from '@mui/material/TextField';
import {initialFile} from './AddEditModal';
import { Stack } from '@mui/material';
import RadioGroup from '@mui/material/RadioGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import Radio from '@mui/material/Radio';
import {UploadStage, UploadStageFile} from "../../../api/stage/getStages";

const fileInputOptions = new Array(6).fill(0).map((_, index) => ({
    id: (index + 1).toString(),
    label: `${index + 1} ${index === 0 ? 'File' : 'Files'}`
}))

type FilesFormProps = {
    formData: UploadStage,
    updateFormData: (newValues: UploadStage) => void
}

export const FilesForm = (props: FilesFormProps) => {
    const {formData, updateFormData} = props

    return (
        <>
            <Autocomplete
                disableClearable
                options={fileInputOptions}
                renderInput={(params) => <TextField {...params} label="Files" />}
                value={fileInputOptions[formData.files.length - 1]}
                onChange={(e, newValue) => {
                    const newValueFormatted = Number(newValue.id)

                    if (newValueFormatted > formData.files.length) {
                        const newFilesList = new Array<UploadStageFile>(newValueFormatted - formData.files.length).fill(initialFile)

                        updateFormData({...formData, files: formData.files.concat(newFilesList)})
                    } else {
                        updateFormData({...formData, files: formData.files.slice(0, newValueFormatted)})
                    }
                }}
            />

            <Stack gap="0.5rem">
                {
                    formData.files.map((file, index) => {
                        const onChange = (newFile: UploadStageFile) => {
                            const newFilesList = [...formData.files]
                            newFilesList[index] = newFile

                            updateFormData({...formData, files: newFilesList})
                        }

                        return (
                            <Stack key={index} direction="row" gap="1rem" alignItems="center">
                                <TextField
                                    label={`File #${index + 1} title`}
                                    variant="outlined"
                                    value={file.title}
                                    onChange={(e) => onChange({title: e.target.value, type: file.type})}
                                />

                                <RadioGroup
                                    row
                                    aria-labelledby="waiting-period-label"
                                    value={file.type}
                                    onChange={(e) => {
                                        switch (e.target.value) {
                                            case 'image':
                                            case 'pdf': onChange({title: file.title, type: e.target.value}); break;
                                        }
                                    }}
                                >
                                    <FormControlLabel value="image" control={<Radio />} label="Image" />
                                    <FormControlLabel value="pdf" control={<Radio />} label="pdf" />
                                </RadioGroup>
                            </Stack>
                        )
                    })
                }
            </Stack>
        </>
    )
}
